import { useState } from 'react'
import Dropzone from 'react-dropzone'

import { Box } from '@factorialco/deprecated-design-system'

import { Authorized } from 'modules/core/components/Authorized'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useEffect } from 'modules/core/hooks/useEffect'

type Props = {
  onDrop: (files: File[]) => void
  multiple?: boolean
  children: React.ReactNode
  onDragging?: (isDragging: boolean) => void
}

const DraggableDatatable = ({ onDrop, multiple = true, children, onDragging }: Props) => {
  const {
    company: { subscription },
  } = useCurrentSession()
  const [isDragging, setIsDragging] = useState(false)

  const onDragEnter = () => {
    setIsDragging(true)
  }

  const onDragLeave = () => {
    setIsDragging(false)
  }

  useEffect(() => {
    onDragging?.(isDragging)
  }, [isDragging])

  return (
    <Authorized subscription={subscription}>
      <Dropzone
        onDrop={onDrop}
        multiple={multiple}
        noClick
        onDragEnter={onDragEnter}
        onDragLeave={onDragLeave}
      >
        {({ getRootProps, getInputProps, isDragActive }) => {
          return (
            <div {...getRootProps()} style={{ outline: 'none' }}>
              <Box
                border={{
                  all: {
                    width: 's1',
                    style: isDragActive ? 'dashed' : 'hidden',
                    color: 'viridian1000',
                  },
                }}
                background={isDragActive ? 'viridian100' : undefined}
                borderRadius={{ all: 'abs008' }}
              >
                <input {...getInputProps()} />
                {children}
              </Box>
            </div>
          )
        }}
      </Dropzone>
    </Authorized>
  )
}

export default DraggableDatatable
